import { FC, useState, ChangeEvent, FormEvent } from "react";
import { Input } from "../../components/ui/Input";
import { Button } from "../../components/ui/Button";
import Eye from "../../assets/icons/eye.svg?react";
import EyeSlash from "../../assets/icons/eyeSlash.svg?react";
import { validatePassword } from "../../utils";
import { changePassword } from "../../services/authService";
import { useAuth } from "../../contexts/AuthContext";

export const ChangePassword: FC = () => {
    const [form, setForm] = useState<{ [key: string]: { value: string, error: string } }>({ oldPassword: { value: '', error: '' }, newPassword: { value: '', error: '' } });
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const { setIsAuthOpen } = useAuth();

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setForm(prev => ({ ...prev, [e.target.name]: { ...prev[e.target.name], value: e.target.value, error: '' } }));
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validatePassword(form.oldPassword.value)) {
            setForm(prev => ({ ...prev, oldPassword: { ...prev.oldPassword, error: validatePassword(form.oldPassword.value) } }));
        } else if (validatePassword(form.newPassword.value)) {
            setForm(prev => ({ ...prev, newPassword: { ...prev.newPassword, error: validatePassword(form.newPassword.value) } }));
        } else if (form.newPassword.value === form.oldPassword.value) {
            setForm(prev => ({ ...prev, newPassword: { ...prev.newPassword, error: 'New password should not be same as old password' } }));
        } else {
            changePassword({ oldPassword: form.oldPassword.value, newPassword: form.newPassword.value }).then(response => {
                setIsAuthOpen(false);
            }).catch(error => {
                setForm(prev => ({ ...prev, oldPassword: { ...prev.oldPassword, error: error.response.data.message } }));
            });
        }
    };

    return (
        <section className="flex flex-col gap-4 w-full">
            <h2 className="sm:text-2xl text-xl font-medium text-center text-white">Change Password</h2>
            <form className="flex flex-col gap-4" noValidate onSubmit={handleSubmit}>
                <Input
                    variant="secondary"
                    type={showOldPassword ? "text" : "password"}
                    name="oldPassword"
                    label="Old Password"
                    placeholder="Enter your old password"
                    maxLength={20}
                    error={form.oldPassword.error}
                    value={form.oldPassword.value}
                    onChange={handleChange}
                    iconPosition="trailing"
                    icon={showOldPassword ? <Eye /> : <EyeSlash />}
                    onIconClick={() => setShowOldPassword(!showOldPassword)}
                    className={`w-full`}
                />
                <Input
                    variant="secondary"
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    label="New Password"
                    placeholder="Enter your new password"
                    maxLength={20}
                    error={form.newPassword.error}
                    value={form.newPassword.value}
                    onChange={handleChange}
                    iconPosition="trailing"
                    icon={showNewPassword ? <Eye /> : <EyeSlash />}
                    onIconClick={() => setShowNewPassword(!showNewPassword)}
                    className={`w-full`}
                />
                <Button
                    type="submit"
                    variant="primary"
                    className="w-full mt-2"
                >
                    Change Password
                </Button>
            </form>
        </section>
    );
};